import type { RunRowLike } from "@/types/RunRow"

/**
 * Filters run rows by selected mutation IDs.
 * When no IDs are selected, all rows are returned.
 * When IDs are selected, only rows whose mutation_id is in the set are returned.
 * Uses IDs under the hood (mutation_id on the row).
 */
export function applyMutationFilters(
  runRows: RunRowLike[],
  selectedMutationIds: string[],
): RunRowLike[] {
  if (selectedMutationIds.length === 0) {
    return runRows
  }

  const idSet = new Set(selectedMutationIds)
  return runRows.filter((row) => {
    const rowMutationId = row.mutation_id ?? null
    if (rowMutationId === null) {
      return false
    }
    return idSet.has(rowMutationId)
  })
}
